<template>
  <p v-if="price.isShowTax && price" class="product-tax">
    <span class="product-tax__title">{{ messages?.tax }} ({{ price?.printTaxPercent }}):</span>
    <span class="product-tax__text"> + {{ price?.printTax }} </span>
  </p>
  <p v-else class="product-tax">
    {{ productMessages?.priceWithoutTax }}
  </p>
</template>

<script lang="ts" setup>
import { useStore } from '@/store';
import { computed } from 'vue';

const { state } = useStore();

const price = computed(() => state.product?.data?.product?.price);
const messages = computed(() => state.results?.messages);
const productMessages = computed(() => state.product.data.messages);
</script>

<style lang="scss" scoped>
.product-tax {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f5f5f5;
  min-height: 34px;
  padding: 8px 12px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  &__title {
    color: #3f3f44;
  }
  &__text {
    font-weight: 600;
    color: var(--color-main);
  }
}
</style>
